// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ag-theme-material {\n  --ag-row-hover-color: #f3faff;\n}\n\n/* Removes the highlight when the user clicks on a data grid cell */\n.ag-theme-material\n  .ag-ltr\n  .ag-has-focus\n  .ag-cell-focus:not(.ag-cell-range-selected) {\n  border: none;\n}\n\n.ag-theme-material .task-row.ag-row-focus {\n  background-color: #e9f6ff;\n}\n", ""]);
// Exports
module.exports = exports;
